<template>
	<div class="flex flex-col gap-2 rounded-md border border-won-gray-light bg-won-sand-light p-2">
		<span class="flex items-center gap-1">
			<LockIcon
				color="#6B7280"
				classes="size-3"
			/>

			<span class="text-[12px] font-medium text-won-secondary">{{ maxPoints }} Points Unavailable</span>
		</span>

		<p
			v-if="role"
			class="text-[14px] text-won-black"
		>
			We don't have enough data to score resumes against <span class="font-medium">{{ role }}</span> yet.
			We're adding this role, your full score will update automatically once it's ready.
		</p>

		<p
			v-else
			class="text-[14px] text-won-black"
		>
			Alignment scoring compares your resume against a specific role. Set your target role above to unlock these points.
		</p>
	</div>
</template>

<script setup>
import LockIcon from '../../icons/lock-icon.vue';

// EN-799: Target Alignment's 40 points, shown locked rather than lost while there's no role to
// score them against. EN-814: either no role is set yet (or the one we have still needs
// confirming), or it's a role no profile covers. The server records that role as a request
// for us to build, so the copy says we're adding it rather than asking the user to.
defineProps({
	// The role no profile covers yet; empty while the user still has to set one.
	role: {
		type: String,
		default: '',
	},
	maxPoints: {
		type: Number,
		default: 40,
	},
});
</script>
